import classNames from "classnames";
import * as GIO from "giojs";
import React, { useEffect } from "react";
import { useStoreState, useStoreActions } from "../../store";

const defaultColors = {
  surface: "#FFFFFF",
  selected: "#479DFF"
};

const valentineColors = {
  surface: "#F71CFF",
  selected: "#FF1C9D"
};

export function GlobeThree() {
  const worldRef = React.useRef();
  const controllerRef = React.useRef<any>({ current: null });

  const valentineMode = useStoreState(s => s.valentineMode);
  const focusedCountry = useStoreState(s => s.focusedCountry);
  const sidebarOpen = useStoreState(s => s.sidebarOpen);
  const setDetailsCountry = useStoreActions(s => s.setDetailsCountry);

  useEffect(() => {
    controllerRef.current = new GIO.Controller(worldRef.current);

    const controller = controllerRef.current;

    controller.configure({
      control: {
        initCountry: "PL",
        transparentBackground: true
      },
      color: defaultColors,
      brightness: {
        ocean: 1
      }
    });

    controller.onCountryPicked(selectedCountry => {
      setDetailsCountry(selectedCountry);
    });
    controller.init();

    const camera = controller.getScene().children[4];
    camera.position.set(0, 0, 1100);
  }, []);

  // show focused country (during game mode)
  useEffect(() => {
    controllerRef.current.switchCountry(focusedCountry);
  }, [focusedCountry]);

  // update colors for valentine mode
  useEffect(() => {
    controllerRef.current.configure({
      color: valentineMode ? valentineColors : defaultColors
    });
  }, [valentineMode]);

  // update globe position when viewing country information
  useEffect(() => {
    const camera = controllerRef.current.getScene().children[4];
    camera.position.set(sidebarOpen ? 100 : 0, 0, 1100);
  }, [sidebarOpen]);

  return (
    <div
      className={classNames(
        "map-container",
        valentineMode && "map-container--valentine"
      )}
      ref={worldRef}
    />
  );
}
